// ======================================================================
// File Name       : ServiceNoticeRegisterUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import TableHead from '../../TableHead';
import { VALIDATE_TYPE } from '../../../constants/index';

class ServiceNoticeRegisterUserList extends React.Component {
  render() {
    const { edittingUsers, showModal, removeUserFromList, isConfirm } = this.props;
    let thead = [
      { title: 'ログインID', sortBy: null },
      { title: 'ユーザー名', sortBy: null },
      { title: '所属グループ名', sortBy: null },
      { title: '操作', sortBy: null, width: 75 },
    ];
    if (isConfirm) {
      thead = [
        { title: 'ログインID', sortBy: null },
        { title: 'ユーザー名', sortBy: null },
        { title: '所属グループ名', sortBy: null },
      ];
    }
    let tbody = null;
    if (edittingUsers && edittingUsers.allSecernIds && edittingUsers.allSecernIds.length) {
      tbody = edittingUsers.allSecernIds.map((userSecernId, index) => {
        const user = edittingUsers.bySecernIds[userSecernId];
        if (!user) {
          return null;
        }
        return (
          <tr key={index}>
            <td className="text-left">{user.loginId}</td>
            <td className="text-left">{user.userName}</td>
            <td className="text-left">{user.groupNames}</td>
            {!isConfirm && (
              <td className="text-center">
                <i
                  className="bi bi-trash cursor_pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    removeUserFromList(userSecernId);
                  }}
                />
              </td>
            )}
          </tr>
        );
      });
    }
    return (
      <Col sm={12} style={{ marginTop: '10px' }}>
        <RenderField
          type="requiredarray"
          name="requiredarray"
          label="ユーザー一覧"
          arrayLength={tbody ? tbody.length : 0}
          validates={[VALIDATE_TYPE.REQUIRED_ARRAY]}
          keyArrayToCheck="edittingUserList"
        />
        <Table striped hover>
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </Col>
    );
  }
}

export default ServiceNoticeRegisterUserList;
